
export const CREATE_TRACK_MOD_LOG = 'CREATE_TRACK_MOD_LOG'
export const CREATE_TRACK_MOD_LOG_PENDING = 'CREATE_TRACK_MOD_LOG_PENDING'
export const CREATE_TRACK_MOD_LOG_SUCCESS = 'CREATE_TRACK_MOD_LOG_SUCCESS'
export const CREATE_TRACK_MOD_LOG_FAILURE = 'CREATE_TRACK_MOD_LOG_FAILURE'
